import axios, { AxiosResponse } from 'axios'
import { PageResponseFaturaProfissionalList } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const FINANCEIRO_URL = `${API_URL}/financeiro`
const FINANCEIRO_PROFISSIONAL_ATENDIMENTOS_FATURA_URL = `${FINANCEIRO_URL}/fatura/profissional/atendimento`

/**
 * Busca atendimentos de uma fatura de profissional
 * @param idFatura ID da Fatura
 * @param query string
 * @returns PageResponseFaturaProfissionalList
 */
export const getProfissionalAtendimentosByFatura = (
  idFatura: number,
  query: string
): Promise<PageResponseFaturaProfissionalList> => {
  return axios
    .get(`${FINANCEIRO_PROFISSIONAL_ATENDIMENTOS_FATURA_URL}/${idFatura}?${query}`)
    .then((resp: AxiosResponse<PageResponseFaturaProfissionalList>) => resp.data)
}
